export default __webpack_public_path__ + "static/media/PegasGallery5.252d7453.jpg";